<script>
	import Chart from "chart.js";
	import {onMount, beforeUpdate} from "svelte";
	import {docs} from "../store.js";
	
	export let local;
	let ctx,graph;
	let muestra = 1;
	let nombre = "Año";
	let data = [],labels = [],cajas = [],historia = [];
	let dias = {};
	let mes = [
		'Enero','Febrero','Marzo',
		'Abril','Mayo','Junio',
		'Julio','Agosto','Septiembre',
	'Octubre','Noviembre','Diciembre'
	];
	let config = {
		type: "bar",
		maintainAspectRatio: true,
		options:{
			legend: {
				display: false,
			},
			tooltips:{
				callbacks:{
					label: function(tooltipItems, data){
						return '$' + tooltipItems.yLabel;
					}
				}
			},
			scales: {
        xAxes: [{
					gridLines: false,
					scaleLabel: false,
					ticks: {
						display: false
					}
				}],
				yAxes: [{
					gridLines: false,
					scaleLabel: false,
					ticks: {
						display: false
					}
				}]
			}
		},
      	data: {
			labels: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
			datasets: [
				{
					backgroundColor: "rgb(255, 99, 132)",
					borderColor: "rgb(255, 99, 132)",
					data: [0,0,0,0,0,0,0,0,0,0,0,0]
				}
			]
		}
	};
	let ventas = [];
	function cambiar(){
		if (muestra == 2){
			muestra = 3;
			nombre = "Semana";
		} else if (muestra == 0) {
			muestra = 1;
			nombre = "Año";
		}
		else if (muestra == 1) {
			muestra = 2;
			nombre = "Mes";
		}
		else if (muestra == 3) {
			muestra = 0;
			nombre = "Día";
		}
	}
	onMount(async ()=>{
		ctx = document.getElementById(local.nombre).getContext("2d");
		graph = new Chart(ctx,config);
	})
	function obtenerSemana(d) {
		// 1) Convert date to Y M D
		var Y = d.getFullYear();
		var M = d.getMonth();
		var D = d.getDate();
		
		// 2) Find out if Y is a leap year
		var isLeapYear = (Y % 4 == 0  &&  Y % 100 != 0) || Y % 400 == 0;
		
		// 3) Find out if Y-1 is a leap year
		var lastYear = Y - 1;
		var lastYearIsLeap = (lastYear % 4 == 0  &&  lastYear % 100 != 0) || lastYear % 400 == 0;
		
		// 4) Find the Day of Year Number for Y M D
		var month = [0,31,59,90,120,151,181,212,243,273,304,334];
		var DayOfYearNumber = D + month[M];
		if(isLeapYear && M > 1)
			DayOfYearNumber++;
		
		// 5) Find the weekday for Jan 1 (monday = 1, sunday = 7)
		var YY = (Y-1) % 100; // ...
		var C = (Y-1) - YY; // get century
		var G = YY + YY/4; // ...
		var Jan1Weekday = 1 + (((((C / 100) % 4) * 5) + G) % 7);
		
		// 6) Find the weekday for Y M D
		var H = DayOfYearNumber + (Jan1Weekday - 1);
		var Weekday = 1 + ((H -1) % 7);
		
		var YearNumber = Y;
		var WeekNumber;
		// 7) Find if Y M D falls in YearNumber Y-1, WeekNumber 52 || 53
		if (DayOfYearNumber <= (8-Jan1Weekday) && Jan1Weekday > 4)
		{
			YearNumber = Y - 1;
			if (Jan1Weekday == 5 || (Jan1Weekday == 6 && isLeapYear))
			{
				WeekNumber = 53;
			} else
			{ 
				WeekNumber = 52;
			}
		}
		
		// 8) Find if Y M D falls in YearNumber Y+1, WeekNumber 1
		if (YearNumber == Y)
		{
			var I = 365;
			if (isLeapYear)
			{ 
				var I = 366;
			}
			if (I - DayOfYearNumber < 4 - Weekday)
			{
				YearNumber = Y + 1;
				WeekNumber = 1;
			}
		}
		
		// 9) Find if Y M D falls in YearNumber Y, WeekNumber 1 through 53
		if (YearNumber == Y)
		{
			var J = DayOfYearNumber + (7 - Weekday) + (Jan1Weekday -1);
			WeekNumber = J / 7;
			if (Jan1Weekday > 4)
			{
				WeekNumber--;
			}
		}
		
		return WeekNumber;
	};
	beforeUpdate(()=>{
		if (graph){
			let cajas = $docs.filter((el)=>el._id.includes(`registro:${local.nombre}`));
			if (nombre == "Día"){
				dias = {};
				labels = [];
				data = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let fecha2 = new Date(el.fecha);
					let hoy = new Date();
					hoy.setHours(0,0,0,0);
					fecha.setHours(0,0,0,0);
					if (fecha.getTime() == hoy.getTime()){
						if (dias[fecha2.getHours()]){
							dias[fecha2.getHours()].push(el);
						} else {
							dias[fecha2.getHours()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = 0;
					let gasto = 0;
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso += reg.monto;
								break;
							case "Gasto":
								gasto += reg.monto;
								break;
							case "Pago":
								gasto += reg.monto;
								break;
						}
					})
					let ff = new Date(Number(key));
					labels.push(`${key}:00Hs`);
					data.push(ingreso);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgb(255, 99, 132)",
							borderColor: "rgb(255, 99, 132)",
							data: data
						}
					]
				}
				graph.update();
			}//fin de dia
			if (nombre == "Semana"){
				dias = {};
				labels = [];
				data = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let hoy = new Date();
					fecha.setHours(0,0,0,0);
					if (obtenerSemana(hoy) == obtenerSemana(fecha)){
						if (dias[fecha.getTime()]){
							dias[fecha.getTime()].push(el);
						} else {
							dias[fecha.getTime()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = 0;
					let gasto = 0;
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso += reg.monto;
								break;
							case "Gasto":
								gasto += reg.monto;
								break;
							case "Pago":
								gasto += reg.monto;
								break;
						}
					})
					let ff = new Date(Number(key));
					labels.push(`${ff.getDate()}/${ff.getMonth()+1}/${ff.getFullYear()}`);
					data.push(ingreso);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgb(255, 99, 132)",
							borderColor: "rgb(255, 99, 132)",
							data: data
						}
					]
				}
				graph.update();
			}//fin de semana
			if (nombre == "Mes"){
				dias = {};
				labels = [];
				data = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let hoy = new Date();
					fecha.setHours(0,0,0,0);
					if (fecha.getMonth() == hoy.getMonth()){
						if (dias[fecha.getTime()]){
							dias[fecha.getTime()].push(el);
						} else {
							dias[fecha.getTime()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = 0;
					let gasto = 0;
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso += reg.monto;
								break;
							case "Gasto":
								gasto += reg.monto;
								break;
							case "Pago":
								gasto += reg.monto;
								break;
						}
					})
					let ff = new Date(Number(key));
					labels.push(`${ff.getDate()}/${ff.getMonth()+1}/${ff.getFullYear()}`);
					data.push(ingreso);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgb(255, 99, 132)",
							borderColor: "rgb(255, 99, 132)",
							data: data
						}
					]
				}
				graph.update();
			}//fin de mes
			if (nombre == "Año"){
				dias = {};
				labels = [];
				data = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let hoy = new Date();
					if (fecha.getFullYear() == hoy.getFullYear()){
						if (dias[fecha.getMonth()]){
							dias[fecha.getMonth()].push(el);
						} else {
							dias[fecha.getMonth()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = 0;
					let gasto = 0;
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso += reg.monto;
								break;
							case "Gasto":
								gasto += reg.monto;
								break;
							case "Pago":
								gasto += reg.monto;
								break;
						}
					})
					labels.push(`${mes[key]}`);
					data.push(ingreso);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgb(255, 99, 132)",
							borderColor: "rgb(255, 99, 132)",
							data: data
						}
					]
				}
				graph.update();
			}//fin de año
		}
	})
</script>
<div class="bg-white w-full my-2 sm:my-0 rounded shadow flex flex-col relative">
	<div class="w-full flex items-center justify-between">
		<h1 class="text-xl font-bold m-2">{local.nombre}</h1>	
	</div>
	<div class="absolute top-10 left-2 text-xs">Valor en Pesos</div>
	<a class="p-2 m-2 bg-red-500 text-white flex items-center justify-center rounded shadow absolute top-2 right-2" href={`#/local/${local.id}`}>Ver más</a>
	<a class="p-2 m-2 bg-red-500 text-white flex items-center justify-center rounded shadow absolute top-2 right-24" href={`#/local2/${local.nombre}`}>online</a>
	<div class="w-full relative h-350-px">
		<canvas id={local.nombre} />
	</div>
	<div class="w-full flex items-center justify-end p-2">
		<button class="m-2 p-2 bg-red-500 text-white rounded shadow" on:click={cambiar}>{nombre}</button>
	</div>
</div>

